$(document).ready(function() {
  $(document).on('click', '.commissions-deals-awaiting-payment-component .payment-received-btn', function() {
    const button = $(this)
    const parentTab = button.closest('.tab-pane')
    const parentRow = button.closest('tr')
    const invoiceNumInput = parentRow.find('.invoice-number-input').val()
    const paymentReceivedDate = parentRow.find('.payment-received-input').val()
    const hsDealId = parentRow.attr('hs_deal_id')

    $.post(`/components/commissions/deals_awaiting_payment/assign_commission_period?hs_deal_id=${hsDealId}&invoice_num=${invoiceNumInput}&payment_received_date=${paymentReceivedDate}`).done(function(response) {
      button.remove()
      parentRow.find('.deal-paid-flag').removeClass('d-none')
      parentRow.addClass('grayed-out-paid')

      const parentTabId = parentTab.attr('id')
      const tabPanes = parentTab.closest('.card-body').find('.tab-pane')

      tabPanes.each((index) => {
        const ele = tabPanes[index]
        const component = $(ele).find('.manage-tab')
        const tabId = ele.id
        const tabParam = tabId.split('-').slice(0, -1).join('_')

        if (tabId !== parentTabId) {
          $.get(`/components/commissions/manage?tab=${tabParam}`).done(function(html) {
            component.replaceWith(html)
          })
        }
      })

    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.error("Ajax request failed:", jqXHR.responseText, textStatus, errorThrown);
      alert(jqXHR.responseText);
    });
  })

  $(document).on('click', '#commissions-personal-page #commissions-breakdown .employee-commission-row', function() {
    const hiddenTable = $(this).find('table')
    if (hiddenTable.hasClass('d-none')) {
      $(this).find('table').removeClass('d-none')
      $(this).find('div').addClass('highlight-name')
    } else {
      $(this).find('table').addClass('d-none')
      $(this).find('div').removeClass('highlight-name')
    }
  });


  $(document).on('change', '#commissions-personal-page #commission-overview .select-pay-period', function() {
    const holder = $(this).closest('#commissions-personal-page')
    const parent = $(this).closest('.commissions-individual-component')
    const hsUserId = holder.attr('hs_user_id')
    const payPeriodId = $(this).val()

    $.get(`/components/commissions/individual?hs_user_id=${hsUserId}&commission_period_id=${payPeriodId}`).done(function(html) {
      parent.replaceWith(html)

    }).fail(function(jqXHR, textStatus, errorThrown) {
      console.error("Ajax request failed:", textStatus, errorThrown);
    });
  })

});
